export default __webpack_public_path__ + "static/media/infographics.d96b988b.webp";